'use client'

import { createContext, useState, useContext, useEffect, useCallback } from 'react'
import axios from 'axios'

const PresaleContext = createContext(null)

const API_URL = process.env.REACT_APP_API_URL
const API_Token = process.env.REACT_APP_API_TOKEN



const poolsData = [
    {
        "type": "public_pool",
        "title": "CT Degen Pool",
        "subTitle": "Shitposters unite, Make rugs grot again.",
        "twitter": "",
        "buttonTitle": "Buy $b-Oscar",
        "swap_url": "https://jup.ag/swap/SOL-GhTRW5zVYUTn1UhcBc2JdVdMqnvWi3dfPbBytuof9tAh",
        "pool_address": "DhtdnVrAHnxFN8Br2xWYWpyGVT4ZSUdLYuB2Qo5JHWs3",
        "initial_supply": 10000000,
        "reserve_x": "b-Oscar",
        "reserve_y": "SOL",
        "token_x_icon": "https://wsrv.nl/?w=48&h=48&url=https%3A%2F%2Fipfs.io%2Fipfs%2FQmRBXc8fRjYKH4xzzoEf6YwZsHyMs9NBDfSBDH3EarovT8",
        "token_y_icon": "https://wsrv.nl/?w=48&h=48&url=https%3A%2F%2Fraw.githubusercontent.com%2Fsolana-labs%2Ftoken-list%2Fmain%2Fassets%2Fmainnet%2FSo11111111111111111111111111111111111111112%2Flogo.png",
        "end-date": "2025-06-30T12:00",
        "name": "b-Oscar-SOL",
        "mint_x": "GhTRW5zVYUTn1UhcBc2JdVdMqnvWi3dfPbBytuof9tAh",
        "mint_y": "So11111111111111111111111111111111111111112",
        "reserve_x_amount": "9,999,809.95",
        "reserve_y_amount": "0.21",
        "base_fee_percentage": "5",
        "max_fee_percentage": "10",
        "liquidity": "37.7447",
        "current_price": "0.001",
        "current_progress": "1",
        "progress_label": "9,999,809 / 10,000,000",
        "tvl_usd": "1,805,506",
        "price_label": "0.001 SOL/b-Oscar"
    },
    {
        "type": "public_pool",
        "title": "Shillin Villains Pool",
        "subTitle": "@ShiLLin_ViLLian",
        "twitter": "https://x.com/ShiLLin_ViLLian",
        "buttonTitle": "Buy $OSCR.SV",
        "swap_url": "https://jup.ag/swap/SOL-DXx9x3cciSg1LF9tjBEvZqUsdpaj8ZN7h2v7HjUTZNAC",
        "pool_address": "4PSC1kB5ZDYrVBB2m2vXJTchkcGAeWyWD3DmiiQzp37P",
        "initial_supply": 10000000,
        "reserve_x": "OSCR.SV",
        "reserve_y": "SOL",
        "token_x_icon": "https://wsrv.nl/?w=48&h=48&url=https%3A%2F%2Fipfs.solanatracker.io%2Fipfs%2FQmR6RrHbw97v2AYxtffnfiEjFXuFR4Dw2U3zoHqDLEdkn8%3FpinataGatewayToken%3DdAL99mmS0J-Sf-ogyIXRFLq1o-DBTqOvBlh-UC5mPqLRQyk_ujuCW2ffJ5a1GnGL",
        "token_y_icon": "https://wsrv.nl/?w=48&h=48&url=https%3A%2F%2Fraw.githubusercontent.com%2Fsolana-labs%2Ftoken-list%2Fmain%2Fassets%2Fmainnet%2FSo11111111111111111111111111111111111111112%2Flogo.png",
        "end-date": "2025-06-30T12:00",
        "name": "$OSCR.SV-SOL",
        "mint_x": "DXx9x3cciSg1LF9tjBEvZqUsdpaj8ZN7h2v7HjUTZNAC",
        "mint_y": "So11111111111111111111111111111111111111112",
        "reserve_x_amount": "9,999,999.99",
        "reserve_y_amount": "0",
        "base_fee_percentage": "0.01",
        "max_fee_percentage": "0.03",
        "liquidity": "0.00387",
        "current_price": "0.00005",
        "current_progress": "1",
        "progress_label": "9,999,999 / 10,000,000",
        "tvl_usd": "96,229",
        "price_label": "0.00005 SOL/OSCR.SV"
    },
    {
        "type": "public_pool",
        "title": "Kook Kapital Pool",
        "subTitle": "@KookCapitalLLC",
        "twitter": "https://x.com/KookCapitalLLC",
        "buttonTitle": "Buy $OSCRKOOK",
        "swap_url": "https://jup.ag/swap/SOL-8zanafXx5GDXwxR7e5Yq4HZZSDYtsRRQx56nQUB7591i",
        "pool_address": "7LYDLV67WrjYyh6LrTHJTZ6keVvPHwVHkefuWhnrrSMR",
        "initial_supply": 10000000,
        "reserve_x": "OSCRKOOK",
        "reserve_y": "SOL",
        "token_x_icon": "https://wsrv.nl/?w=48&h=48&url=https%3A%2F%2Fipfs.solanatracker.io%2Fipfs%2FQmPRcQiCmZcoFGzDTHWZC845gVz5KpZ8PuGaurNdgqk6X4%3FpinataGatewayToken%3DdAL99mmS0J-Sf-ogyIXRFLq1o-DBTqOvBlh-UC5mPqLRQyk_ujuCW2ffJ5a1GnGL",
        "token_y_icon": "https://wsrv.nl/?w=48&h=48&url=https%3A%2F%2Fraw.githubusercontent.com%2Fsolana-labs%2Ftoken-list%2Fmain%2Fassets%2Fmainnet%2FSo11111111111111111111111111111111111111112%2Flogo.png",
        "end-date": "2025-06-30T12:00",
        "name": "OSCRKOOK-SOL",
        "mint_x": "8zanafXx5GDXwxR7e5Yq4HZZSDYtsRRQx56nQUB7591i",
        "mint_y": "So11111111111111111111111111111111111111112",
        "reserve_x_amount": "10,000,000",
        "reserve_y_amount": "0",
        "base_fee_percentage": "0.01",
        "max_fee_percentage": "0.03",
        "liquidity": "0",
        "current_price": "0.00005",
        "current_progress": "1",
        "progress_label": "9,999,999 / 10,000,000",
        "tvl_usd": "96,229",
        "price_label": "0.00005 SOL/OSCRKOOK"
    },
    {
        "type": "public_pool",
        "title": "Sweepers Syndicate",
        "subTitle": "@0xSweep",
        "twitter": "https://x.com/0xSweep",
        "buttonTitle": "Buy $OSCR.SWP",
        "swap_url": "https://jup.ag/swap/SOL-3UgVV8BjhDn54yWrEiwvAUpdwaRE7FdfGEzFNqkch7KE",
        "pool_address": "E15UQKvoxT9XHfDotgSmEo9Zw52NPfD36VHMj1bcVE74",
        "initial_supply": 10000000,
        "reserve_x": "OSCR.SWP",
        "reserve_y": "SOL",
        "token_x_icon": "https://wsrv.nl/?w=48&h=48&url=https%3A%2F%2Fipfs.solanatracker.io%2Fipfs%2FQmZ4uVsF7xqt7Lpcdqt9UvCzxs5aPtMJL7CWaE7KcBANJt%3FpinataGatewayToken%3DdAL99mmS0J-Sf-ogyIXRFLq1o-DBTqOvBlh-UC5mPqLRQyk_ujuCW2ffJ5a1GnGL",
        "token_y_icon": "https://wsrv.nl/?w=48&h=48&url=https%3A%2F%2Fraw.githubusercontent.com%2Fsolana-labs%2Ftoken-list%2Fmain%2Fassets%2Fmainnet%2FSo11111111111111111111111111111111111111112%2Flogo.png",
        "end-date": "2025-06-30T12:00",
        "name": "OSCR.SWP-SOL",
        "mint_x": "3UgVV8BjhDn54yWrEiwvAUpdwaRE7FdfGEzFNqkch7KE",
        "mint_y": "So11111111111111111111111111111111111111112",
        "reserve_x_amount": "0",
        "reserve_y_amount": "0",
        "base_fee_percentage": "0.01",
        "max_fee_percentage": "0.03",
        "liquidity": "0",
        "current_price": "18,760.47181",
        "current_progress": "0",
        "progress_label": "0 / 10,000,000",
        "tvl_usd": "0",
        "price_label": "18,760.47181 SOL/OSCR.SWP"
    },
    {
        "type": "public_pool",
        "title": "Cozy Callers Pool",
        "subTitle": "@cozypront",
        "twitter": "https://x.com/cozypront",
        "buttonTitle": "Buy $OSCRCOZY",
        "swap_url": "https://jup.ag/swap/SOL-9PPTwCyVuBmzm896k8aShAcQqe6ebxHqirCELSFqFmPu",
        "pool_address": "84QFaNXR6aiMbf9C6mM2QGiHqNCcxoiGuiaq9hn3pnmy",
        "initial_supply": 10000000,
        "reserve_x": "OSCRCOZY",
        "reserve_y": "SOL",
        "token_x_icon": "https://wsrv.nl/?w=48&h=48&url=https%3A%2F%2Fipfs.solanatracker.io%2Fipfs%2FQmUpGe7uiZwEqMaCiwwRjb9CqjSWb93jE52eAWCPYf4tDo%3FpinataGatewayToken%3DdAL99mmS0J-Sf-ogyIXRFLq1o-DBTqOvBlh-UC5mPqLRQyk_ujuCW2ffJ5a1GnGL",
        "token_y_icon": "https://wsrv.nl/?w=48&h=48&url=https%3A%2F%2Fraw.githubusercontent.com%2Fsolana-labs%2Ftoken-list%2Fmain%2Fassets%2Fmainnet%2FSo11111111111111111111111111111111111111112%2Flogo.png",
        "end-date": "2025-06-30T12:00",
        "name": "OSCRCOZY-SOL",
        "mint_x": "9PPTwCyVuBmzm896k8aShAcQqe6ebxHqirCELSFqFmPu",
        "mint_y": "So11111111111111111111111111111111111111112",
        "reserve_x_amount": "0",
        "reserve_y_amount": "0",
        "base_fee_percentage": "0.01",
        "max_fee_percentage": "0.03",
        "liquidity": "0",
        "current_price": "0.00005",
        "current_progress": "0",
        "progress_label": "0 / 10,000,000",
        "tvl_usd": "0",
        "price_label": "0.00005 SOL/OSCRCOZY"
    },
    {
        "title": "Founders Circle Pool",
        "target_raise": "$300,000 (~2,143 SOL)",
        "token_price": "$0.007",
        "tokens_allocated": "42,857,143 tokens",
        "discount_vs_public_($0.01)": "30% Discount",
        "fast_mover_bonus": "+5% Tokens (First 20 Buyers)",
        "min_buy": "$500",
        "progress": 48,
        "type": "private_pool",
        "end-date": "2025-06-30T12:00"
    },
    {
        "title": "Market Makers Syndicate",
        "target_raise": "$500,000 (~3,571 SOL)",
        "token_price": "$0.007",
        "tokens_allocated": "71,428,571 tokens",
        "discount_vs_public_($0.01)": "30% Discount",
        "fast_mover_bonus": "+5% Tokens (Pool 50% Fill)",
        "min_buy": "$1,000",
        "progress": 29,
        "type": "private_pool",
        "end-date": "2025-06-30T12:00"
    },
    {
        "title": "Genesis Council",
        "target_raise": "$420,000 (~3,000 SOL)",
        "token_price": "$0.007",
        "tokens_allocated": "60,000,000 tokens",
        "discount_vs_public_($0.01)": "30% Discount",
        "fast_mover_bonus": "+7% Tokens (Buy > $10K)",
        "min_buy": "$2,500",
        "progress": 40,
        "type": "private_pool",
        "end-date": "2025-06-30T12:00"
    },
    {
        "title": "Degens Moonshot League",
        "target_raise": "$250,000 (~1,786 SOL)",
        "token_price": "$0.007",
        "tokens_allocated": "35,714,285 tokens",
        "discount_vs_public_($0.01)": "30% Discount",
        "fast_mover_bonus": "+5% Tokens (Refer 1 Buyer)",
        "min_buy": "$250",
        "progress": 62,
        "type": "private_pool",
        "end-date": "2025-06-30T12:00"
    },
    {
        "title": "Blackpool Alpha Club",
        "target_raise": "$1,000,000 (~7,143 SOL)",
        "token_price": "$0.007",
        "tokens_allocated": "142,857,143 tokens",
        "discount_vs_public_($0.01)": "30% Discount",
        "fast_mover_bonus": "+10% Tokens (Buy > $25K)",
        "min_buy": "$25,000",
        "progress": 22,
        "type": "private_pool",
        "end-date": "2025-06-30T12:00"
    },
    {
        "contract_address": "DJm8QYhMBdGcuDitHoGsbCAJJvoMy1SWrJ2H5HBjpump",
        "token_name": "Oscar Anti-Rug Policy 2",
        "token_symbol": "OSCARD2",
        "type": "insurance_pool",
        "category": "daily_launch",
        "holders": 21,
        "special": true,
        "insurance_bonus_tiers": {
            "top_50": "5x $OSCAR",
            "top_100": "4x $OSCAR",
            "top_350": "3x $OSCAR",
            "everyone_else": "2x $OSCAR"
        },
        "token_status": "active",
        "launch_date": "2025-05-08T08:00",
        "cover_image": "OscarD2Launched",
        "coverage_period": "From 8th May"
    }
]

// Provider Component
export const PoolsProvider = ({ children }) => {

    const [isLoading, setIsLoading] = useState(false)
    const [isModalLoading, setIsModalLoading] = useState(false)
    const [pools, setPools] = useState([])
    const [privatePools, setPrivatePools] = useState([])
    const [insurancePools, setInsurancePools] = useState([])
    const [submissions, setSubmissions] = useState([])
    const [privateSubmissions, setPrivateSubmissions] = useState([])
    const [error, setError] = useState(null)

    // Fetch Presale Pools
    const fetchPools = useCallback(async () => {
        setIsLoading(true)
        setError(null)

        try {

            setPools(poolsData.filter(p => p.type == 'public_pool') || [])
            setPrivatePools(poolsData.filter(p => p.type == "private_pool") || [])
            setInsurancePools(poolsData.filter(p => p.type == "insurance_pool") || [])
            // const requestUrl = `${API_URL}/api/presale/pools`
            // const response = await axios.get(requestUrl, {
            //     headers: { 'x-api-key': API_Token }
            // })
            // console.log("response", response)
            // if (response.status === 200) {
            //     setPools(response.data.filter(p => p.type == 'public_pool') || [])
            //     setPrivatePools(response.data.filter(p => p.type == "private_pool") || [])
            //     setInsurancePools(response.data.filter(p => p.type == "insurance_pool") || [])
            // } else {
            //     setError('Something went wrong (P01)')
            // }
        } catch (error) {
            setError('Something went wrong (P02)')
        } finally {
            setIsLoading(false)
        }
    }, [])


    // Fetch Presale Submissions
    const fetchSubmissions = useCallback(async () => {
        setIsModalLoading(true)
        setError(null)

        try {
            setSubmissions([
                {
                    "status": "pending",
                    "_id": "680c776c967c1754a7bef254",
                    "poolName": "Stevbed",
                    "wallet": "J4fG5jRRscHNuS7g4uPHKA5PW3zfJ1CKSjAFsGNZCVG6",
                    "twitter": "@YudhaKris4",
                    "about": "Community ",
                    "type": "Other",
                    "size": "Micro (5k – 15k followers)",
                    "telegram": "",
                    "notes": "",
                    "createDate": "2025-04-26T06:04:28.080Z",
                    "__v": 0
                }
            ])
            // const requestUrl = `${API_URL}/api/presale/submissions`
            // const response = await axios.get(requestUrl, {
            //     headers: { 'x-api-key': API_Token }
            // })

            // if (response.status === 200) {
            //     setSubmissions(response.data || [])
            // } else {
            //     setError('Something went wrong (P03)')
            // }
        } catch (error) {
            setError('Something went wrong (P04)')
            setSubmissions([])
        } finally {
            setIsModalLoading(false)
        }
    }, [])



    // Add Presale Submission
    const addSubmission = async (formData) => {
        setIsModalLoading(true)
        setError(null)

        try {

            return { success: true }

            // const requestUrl = `${API_URL}/api/presale/submissions`
            // const response = await axios.post(requestUrl, formData, {
            //     headers: { 'x-api-key': API_Token }
            // })

            // if (response.status === 200) {
            //     await fetchSubmissions()
            //     return { success: true }
            // } else {
            //     setError('Something went wrong (P05)')
            //     return { success: false }
            // }
        } catch (error) {
            setError('Something went wrong (P06)')
            return { success: false, error: error.message }
        } finally {
            setIsModalLoading(false)
        }
    }



    // Delete Presale Submission
    const deleteSubmission = async (id) => {
        setIsModalLoading(true)
        setError(null)

        try {
            setError('Something went wrong (P07)')
            return { success: false, error: error.message }

            // const requestUrl = `${API_URL}/api/presale/submissions/${id}`
            // const response = await axios.delete(requestUrl, {
            //     headers: { 'x-api-key': API_Token }
            // })

            // if (response.status === 200) {
            //     await fetchSubmissions()
            //     return { success: true }
            // } else {
            //     setError('Something went wrong (P07)')
            // }
        } catch (error) {
            setError('Something went wrong (P08)')
            return { success: false, error: error.message }
        } finally {
            setIsModalLoading(false)
        }

    }


    // Fetch Private Pool Submissions
    const fetchPrivateSubmissions = useCallback(async () => {
        setIsModalLoading(true)
        setError(null)

        try {

            setPrivateSubmissions( [])
            // const requestUrl = `${API_URL}/api/presale/private-submissions`
            // const response = await axios.get(requestUrl, {
            //     headers: { 'x-api-key': API_Token }
            // })

            // if (response.status === 200) {
            //     setPrivateSubmissions(response.data || [])
            // } else {
            //     setError('Something went wrong (P09)')
            // }
        } catch (error) {
            setError('Something went wrong (P10)')
            setPrivateSubmissions([])
        } finally {
            setIsModalLoading(false)
        }
    }, [])



    // Add Private Pool Submission
    const addPrivateSubmission = async (formData) => {
        setIsModalLoading(true)
        setError(null)

        try {
            return { success: true }
            // const requestUrl = `${API_URL}/api/presale/private-submissions`
            // const response = await axios.post(requestUrl, formData, {
            //     headers: { 'x-api-key': API_Token }
            // })
            // if (response.status === 200 || response.status == 201) {
            //     await fetchSubmissions()
            //     return { success: true }
            // } else {
            //     setError('Something went wrong (P05)')
            //     return { success: false }
            // }
        } catch (error) {
            setError('Something went wrong (P06)')
            return { success: false, error: error.message }
        } finally {
            setIsModalLoading(false)
        }
    }



    // Delete Private Pool Submission
    const deletePrivateSubmission = async (id) => {
        setIsModalLoading(true)
        setError(null)

        try {

            setError('Something went wrong (P08)')
            return { success: false, error: error.message }
            
            // const requestUrl = `${API_URL}/api/presale/private-submissions/${id}`
            // const response = await axios.delete(requestUrl, {
            //     headers: { 'x-api-key': API_Token }
            // })

            // if (response.status === 200) {
            //     await fetchSubmissions()
            //     return { success: true }
            // } else {
            //     setError('Something went wrong (P07)')
            // }
        } catch (error) {
            setError('Something went wrong (P08)')
            return { success: false, error: error.message }
        } finally {
            setIsModalLoading(false)
        }

    }


    // Fetch pools and submissions on first load
    useEffect(() => {
        fetchPools()
        fetchSubmissions()
        fetchPrivateSubmissions()
    }, [fetchPools])

    return (
        <PresaleContext.Provider value={{
            isLoading,
            isModalLoading,
            pools,
            privatePools,
            insurancePools,
            fetchPools,
            error,
            submissions,
            privateSubmissions,
            fetchSubmissions,
            addSubmission,
            deleteSubmission,
            fetchPrivateSubmissions,
            addPrivateSubmission,
            deletePrivateSubmission
        }}>
            {children}
        </PresaleContext.Provider>
    )
}


export const usePresale = () => useContext(PresaleContext)